import React from "react";

export default function InputFields({ scheduleCreate, handleInputChange }) {

    const {day, startHour, endHour, level, numberOfPlaces, playedForm, educator} = scheduleCreate
  const inputFields = [
    { name: "day", type: "select", value: day, options: ["Lundi", "Mardi", 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'], label: 'Jour :' },
    { name: "startHour", type: "time", value: startHour, label: 'Début :' },
    { name: "endHour", type: "time", value: endHour, label: 'Fin :' },
    { name: "level", type: "select", value: level, options: ["Baby Tennis",'Mini Tennis', "Violet", "Rouge", "Orange", "Vert", 'Jaune 1 (2013-2016)','Jaune 1 (2009-2012)', 'Jaune 2 (2013-2016)','Jaune 2 (2009-2012)', 'Jaune 3 (2013-2016)','Jaune 3 (2009-2012)', 'Jaune 4', 'Adulte Niveau 1', 'Adulte Niveau 2', 'Adulte Niveau 3',  'Adulte Niveau 4',  'Adulte Niveau 5' ], label: 'Niveau :' },
    { name: "numberOfPlaces", type: "number", value: numberOfPlaces, min: 1, max: 20, label: 'Nombre de places :' },
    { name: "playedForm", type: "select", value: playedForm, options: ["Classique", "Forme Jouée"], label: 'Formule :' },
    { name: "educator", type: "text", value: educator, label: 'Enseignant :' }
  ];

   const convertWordToLevel = (level) => {
    const levelMap = {
      "Baby Tennis": 0,
      "Mini Tennis": 1,
      "Violet": 2,
      "Rouge": 3,
      "Orange": 4,
      "Vert": 5,
      "Jaune 1 (2013-2016)": 61,
      "Jaune 1 (2009-2012)": 62,

      "Jaune 2 (2013-2016)": 71,
      "Jaune 2 (2009-2012)": 72,
      "Jaune 3 (2013-2016)": 81,
      "Jaune 3 (2009-2012)": 82,
      "Jaune 4": 9,
      "Adulte Niveau 1": 10,
      "Adulte Niveau 2": 11,
      "Adulte Niveau 3": 12,
      "Adulte Niveau 4": 13,
      "Adulte Niveau 5": 14,
    };
  
    return levelMap[level] || "Pas renseigné";
  };

  return (
    <div className="inputs-container">
      
      {inputFields.map((field, index) => {
        const {name, type, value, options, label, min, max} = field
        return(
          <div className="inputs" key={index}>
          <label>{label}</label>
          {type === 'select' ? (
                <select name={name} value={value} onChange={ handleInputChange}>
                {options.map((option, index) => (
                    <option key={option} value={name === 'level' ? convertWordToLevel(option) : name === 'playedForm' ? index : option}>{option}</option>
                ))}
            </select>
          ) : type === 'time' ? (
            <input type="time" value={value} name={name} onChange={handleInputChange} />
          ) : type === 'number' ? (
            <input type="number" value={value} min={min} max={max} name={name} onChange={handleInputChange} />
          ) : (
            <input type="text" value={value} name={name} onChange={handleInputChange} />
          )}
        </div>
        )
      })}
    </div>
  );
}